import {
  watchGetContractsType,
  watchgetContractAuto,
  watchgetDetailContractAuto,
  watchgetContractMrh,
  watchAddNewContract,
  watchGetDetailContractMrh,
  watchgetContractEpargn,
  watchgetProduitEpargn,
  watchGetContractsAMCSaga,
  watchGetContractsASISaga,
  watchGetContractAMCDetailsSaga,
} from 'store/contract/saga';

export default [
  watchGetContractsType,
  watchgetContractAuto,
  watchgetDetailContractAuto,
  watchgetContractMrh,
  watchAddNewContract,
  watchGetDetailContractMrh,
  watchgetContractEpargn,
  watchgetProduitEpargn,
  watchGetContractsAMCSaga,
  watchGetContractsASISaga,
  watchGetContractAMCDetailsSaga,
];
